export function getFilenameFromDisposition(headers: Headers, fallback: string) {
  const disposition = headers.get('Content-Disposition');
  if (!disposition) return fallback;

  // Try filename* (RFC 5987)
  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match && utf8Match[1]) {
    return decodeURIComponent(utf8Match[1]);
  }

  // Fallback: plain filename=""
  const asciiMatch = disposition.match(/filename="(.+?)"/i);
  if (asciiMatch && asciiMatch[1]) {
    return asciiMatch[1];
  }

  return fallback;
}
